import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { SearchResult } from "./SearchResult";
export const SearchResultList = ({ resultList }) => {
  return (
    <div className="results-list">
      {resultList.results.map((result, id) => {
        return (
          <SearchResult
            resultProps={resultList}
            result={result.name}
            key={id}
            id={result.id}
            lat={result.lat}
            lng={result.lng}
          />
        );
      })}
    </div>
  );
};
